// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// branch api
import createVehicleDisableScheduleApi from '../../api/createVehicleDisableSchedule.api.branch';
import deleteVehicleDisableScheduleApi from '../../api/deleteVehicleDisableSchedule.api.branch';
import listVehicleDisableSchedulesApi from '../../api/listVehicleDisableSchedules.api.branch';
import updateVehicleDisableScheduleApi from '../../api/updateVehicleDisableSchedule.api.branch';

// branch attributes
import processingAmountAttribute from '../../attributes/processing_amount.attribute.vehicleDisableSchedule';
import scheduleAtAttribute from '../../attributes/schedule_at.attribute.vehicleDisableSchedule';

// branch components
import BranchVehicleDisableModal from '../../components/BranchVehicleDisableModal/BranchVehicleDisableModal';

// attribute lib
import prepare from '@drivesally/sally-fw/lib/attribute/prepare.attribute';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

const sortSchedules = (list) =>
  [...list].sort((a, b) =>
    String(a.schedule_at).localeCompare(String(b.schedule_at))
  );

class BranchVehicleDisableScheduleModalContainer extends Component {
  static propTypes = {
    branch: PropTypes.object,
    onClose: PropTypes.func,
    visible: PropTypes.bool,
  };

  state = {
    deletingId: null,
    editProcessing_amount: processingAmountAttribute(''),
    editSchedule_at: scheduleAtAttribute(''),
    editingId: null,
    loading: false,
    newProcessing_amount: processingAmountAttribute(''),
    newSchedule_at: scheduleAtAttribute(''),
    savingCreate: false,
    savingUpdateId: null,
    schedules: [],
  };

  componentDidMount() {
    if (this.props.visible) {
      this.bootstrap();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.bootstrap();
    }
    if (prevProps.visible && !this.props.visible) {
      this.setState({
        deletingId: null,
        editProcessing_amount: processingAmountAttribute(''),
        editSchedule_at: scheduleAtAttribute(''),
        editingId: null,
        schedules: [],
      });
    }
    if (
      this.props.visible &&
      this.props.branch?.id &&
      prevProps.branch?.id !== this.props.branch?.id
    ) {
      this.loadSchedules();
    }
  }

  bootstrap = () => {
    this.setState({
      deletingId: null,
      editProcessing_amount: processingAmountAttribute(''),
      editSchedule_at: scheduleAtAttribute(''),
      editingId: null,
      newProcessing_amount: processingAmountAttribute(''),
      newSchedule_at: scheduleAtAttribute(''),
    });
    this.loadSchedules();
  };

  loadSchedules = async () => {
    const {branch} = this.props;
    if (!branch?.id) return;
    this.setState({loading: true});
    try {
      const schedules = await listVehicleDisableSchedulesApi({
        sally_branch: branch.id,
      });
      this.setState({schedules: sortSchedules(schedules), loading: false});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({loading: false});
    }
  };

  changeNew = (value, key) => {
    if (key === 'schedule_at') this.setState({newSchedule_at: value});
    if (key === 'processing_amount')
      this.setState({newProcessing_amount: value});
  };

  changeEdit = (value, key) => {
    if (key === 'schedule_at') this.setState({editSchedule_at: value});
    if (key === 'processing_amount')
      this.setState({editProcessing_amount: value});
  };

  startEdit = (schedule) => {
    this.setState({
      editingId: schedule.id,
      editSchedule_at: scheduleAtAttribute(schedule.schedule_at || ''),
      editProcessing_amount: processingAmountAttribute(
        schedule.processing_amount ?? ''
      ),
    });
  };

  cancelEdit = () => {
    this.setState({
      editingId: null,
      editSchedule_at: scheduleAtAttribute(''),
      editProcessing_amount: processingAmountAttribute(''),
    });
  };

  createSchedule = async () => {
    const {branch} = this.props;
    const {newSchedule_at, newProcessing_amount, savingCreate} = this.state;
    if (savingCreate || !branch?.id) return;
    this.setState({savingCreate: true});
    try {
      const prepared = prepare(
        {
          schedule_at: newSchedule_at,
          processing_amount: newProcessing_amount,
        },
        {field: 'api', required: ['schedule_at', 'processing_amount']}
      );
      const created = await createVehicleDisableScheduleApi({
        ...prepared,
        sally_branch: branch.id,
      });
      this.setState((prev) => ({
        schedules: sortSchedules([...prev.schedules, created]),
        newSchedule_at: scheduleAtAttribute(''),
        newProcessing_amount: processingAmountAttribute(''),
        savingCreate: false,
      }));
      alert.success('Schedule created');
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({savingCreate: false});
    }
  };

  saveEdit = async () => {
    const {editingId, editSchedule_at, editProcessing_amount} = this.state;
    if (!editingId) return;
    this.setState({savingUpdateId: editingId});
    try {
      const prepared = prepare(
        {
          schedule_at: editSchedule_at,
          processing_amount: editProcessing_amount,
        },
        {field: 'api', required: ['schedule_at', 'processing_amount']}
      );
      const updated = await updateVehicleDisableScheduleApi(
        editingId,
        prepared
      );
      this.setState((prev) => ({
        schedules: sortSchedules(
          prev.schedules.map((s) => (s.id === updated.id ? updated : s))
        ),
        editingId: null,
        editSchedule_at: scheduleAtAttribute(''),
        editProcessing_amount: processingAmountAttribute(''),
        savingUpdateId: null,
      }));
      alert.success('Schedule updated');
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({savingUpdateId: null});
    }
  };

  deleteSchedule = async (id) => {
    const {deletingId} = this.state;
    if (deletingId !== null) return;
    this.setState({deletingId: id});
    try {
      await deleteVehicleDisableScheduleApi(id);
      this.setState((prev) => ({
        schedules: prev.schedules.filter((s) => s.id !== id),
        editingId: prev.editingId === id ? null : prev.editingId,
        deletingId: null,
      }));
      alert.success('Schedule deleted');
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({deletingId: null});
    }
  };

  render() {
    const {visible, onClose, branch} = this.props;
    return (
      <BranchVehicleDisableModal
        branch={branch}
        cancelEdit={this.cancelEdit}
        changeEdit={this.changeEdit}
        changeNew={this.changeNew}
        createSchedule={this.createSchedule}
        deleteSchedule={this.deleteSchedule}
        deletingId={this.state.deletingId}
        editProcessing_amount={this.state.editProcessing_amount}
        editSchedule_at={this.state.editSchedule_at}
        editingId={this.state.editingId}
        loading={this.state.loading}
        newProcessing_amount={this.state.newProcessing_amount}
        newSchedule_at={this.state.newSchedule_at}
        onClose={onClose}
        saveEdit={this.saveEdit}
        savingCreate={this.state.savingCreate}
        savingUpdateId={this.state.savingUpdateId}
        schedules={this.state.schedules}
        startEdit={this.startEdit}
        visible={visible}
      />
    );
  }
}

export default BranchVehicleDisableScheduleModalContainer;
